import { GetStoryMediaQueryResult } from '../../../hooks/useQueries'

import type { ResponsiveImageProperties } from '../../display/ResponsiveImage/types'

type Photo = {
  image: ResponsiveImageProperties
}

type RegularPhotos = GetStoryMediaQueryResult['data']['story']['photos']
type PortraitCoverImage = GetStoryMediaQueryResult['data']['story']['portraitCoverImage']
type FeaturedListingImage = GetStoryMediaQueryResult['data']['story']['featuredListingImage']
type PromoImage = GetStoryMediaQueryResult['data']['story']['promoImage']

type Args = {
  isPortrait: boolean
  regularPhotos: RegularPhotos
  promoImage: PromoImage
  portraitCoverImage: PortraitCoverImage
  featuredListingImage: FeaturedListingImage
  firstImage?: Photo
}

const composePhotos = ({
  isPortrait,
  regularPhotos,
  promoImage: landscapeCoverImage,
  portraitCoverImage,
  featuredListingImage,
  firstImage,
}: Args): Photo[] => {
  const portraitCoverImageValid =
    portraitCoverImage?.w400?.length > 0 ||
    portraitCoverImage?.w800?.length > 0 ||
    portraitCoverImage?.w1200?.length > 0

  const landscapeCoverImageValid =
    landscapeCoverImage?.medium?.length > 0 ||
    landscapeCoverImage?.large?.length > 0

  const featuredListingImageValid =
    featuredListingImage?.medium?.length > 0 ||
    featuredListingImage?.large?.length > 0

  const portraitCoverImagePhoto = { image: portraitCoverImage }
  const landscapeCoverImagePhoto = { image: landscapeCoverImage }
  const featuredListingImagePhoto = { image: featuredListingImage }

  const coverImageValid = isPortrait
    ? portraitCoverImageValid
    : landscapeCoverImageValid

  const coverImagePhoto = isPortrait
    ? portraitCoverImagePhoto
    : landscapeCoverImagePhoto

  const landscapeCoverMedium = landscapeCoverImage?.medium
  const filteredRegularPhotos = (regularPhotos || []).filter(
    (photo) => photo.image.medium !== landscapeCoverMedium
  )

  const photos = [
    ...(firstImage ? [firstImage] : []),
    ...(coverImageValid ? [coverImagePhoto] : []),
    ...(featuredListingImageValid ? [featuredListingImagePhoto] : []),
    ...filteredRegularPhotos,
  ]

  return photos
}

export default composePhotos
